export const isTypename =
  <T extends string>(typename: T) =>
  <N extends { __typename: T }>(node: N): node is Extract<N, { __typename: T }> =>
    node.__typename === typename;
